import React, { useState } from 'react'
import { t } from 'ttag'
import { Modal } from 'react-bootstrap'
import { actions as formActions, Control, getModel } from 'react-redux-form'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { CSSTransitionGroup } from 'react-transition-group'
import PropTypes from 'prop-types'

import like from '@h2/assets/svg/icons/thumbsUpActive.svg'
import likeInactive from '@h2/assets/svg/icons/thumbsUpInactive.svg'
import dislike from '@h2/assets/svg/icons/thumbsDownActive.svg'
import dislikeInactive from '@h2/assets/svg/icons/thumbsDownInactive.svg'
import { TaskProgressBar } from '@h2/components/display/taskProgressBar'

import { applyProfile } from '../../actions/profileViewActions'
import Form from '../form/Form'
import Field from '../form/Field'
import { receivedResponse } from '../../h2Api'
import ActionButton from '../ActionButton'
import { loadClusterListing } from '../../actions/localopportunities/localopportunities'
import { rateCluster } from '../../actions/clusterProfile'

const ExpressInterest = props => {
  const [modalOpen, setModalOpen] = useState(false)
  const [planIdReturned, setPlanIdReturned] = useState(null)
  const [applicationStep, setApplicationStep] = useState(1)
  const [additional, setAdditional] = useState([])
  const dispatch = useDispatch()
  const applicationFormName = `localOpportunities.userInterestExpressionForm`
  const userInterestExpressionClustersRequest = useSelector(
    state => state.localOpportunities.userInterestExpressionClustersRequest
  )
  const userInterestExpressionFormModel = useSelector(state =>
    getModel(state, applicationFormName)
  )
  const userInterestExpressionRequest = useSelector(
    state => state.localOpportunities.userInterestExpressionRequest
  )
  const { profile } = props
  const actionComplete = () => {
    const iExpression = profile.personalization?.interestExpression
    const assignmentStatusId = iExpression?.status?.id

    return [
      <br key="clearbr" className="clear" />,
      <div key="alreadysubmitted">
        <div style={{ marginTop: '15px' }} className="alert alert-warning text-center">
          <div>
            {assignmentStatusId <= 0
              ? t`You started an application on:`
              : t`You submitted an application on:`}{' '}
            {new Date(iExpression?.dateApplied).toLocaleDateString()}
          </div>
          <div style={{ fontSize: '.9rem', marginTop: '15px' }}>
            <TaskProgressBar pct={100 * (assignmentStatusId / 4)} />
            {t`Status:`} {iExpression?.status?.name}
          </div>
          {assignmentStatusId <= 0 && iExpression?.assignedPlan ? (
            <div style={{ marginTop: '15px' }}>
              <Link
                className="btn btn-sm no-style btn-success"
                to={`/planning/assignments/detail/${iExpression.assignedPlan.id}`}>
                {t`Continue Submission`}
              </Link>
            </div>
          ) : null}
        </div>
      </div>
    ]
  }
  const actionAvailable = () => {
    return (
      <button
        className="btn-full btn btn-success"
        style={{ marginTop: '25px' }}
        onClick={openModal}>
        {profile.wblIsApplication ? t`Apply Now` : t`I'm Interested`}
      </button>
    )
  }
  const actionDisabled = () => {
    return [
      <br key="clearbr2" className="clear" />,
      <div key="disabledapp">
        <div style={{ marginTop: '15px' }} className="alert alert-danger text-center">
          <h4>{t`Applications are not currently being accepted for this offering type`}</h4>
        </div>
      </div>
    ]
  }
  const showAction = () => {
    if (!profile.personalization?.interestExpression) {
      if (profile.applicationsDisabledToWBL && !profile.additionalApplicationText) {
        return actionDisabled()
      }

      return actionAvailable()
    }

    return actionComplete()
  }
  const openModal = () => {
    if (profile.additionalApplicationText) {
      setModalOpen(true)
      setAdditional(null)
    }

    dispatch(loadClusterListing(profile.id)).then(v => {
      dispatch(formActions.reset(applicationFormName))

      // console.log(this.props)
      if (props.selectedCluster) {
        dispatch(
          formActions.change(`${applicationFormName}.clusterId`, props.selectedCluster)
        )
      }

      setModalOpen(true)
      setAdditional(v)
    })
  }
  const closeModal = () => {
    setModalOpen(false)
  }
  const defaultThumb = s => {
    if (!s.image) {
      return null
    }

    return (
      <img
        className="img-rounded"
        width={'100%'}
        height={'100%'}
        src={s.image}
        alt={`Thumbnail for ${s.title}`}
      />
    )
  }
  const updateStateWith = (item, newRating) => {
    const addl = [...additional]
    const idx = addl.indexOf(item)

    if (idx >= 0) {
      const newItem = {
        ...item,
        flag: newRating
      }
      const retVal = [...addl.slice(0, idx), newItem, ...addl.slice(idx + 1)]

      // console.log(retVal, addl, idx);
      setAdditional(retVal)
    }
  }
  const modalChooseTopInterest = () => {
    //console.log(this.props.userInterestExpressionClustersRequest)
    const selected = userInterestExpressionClustersRequest?.result?.find(
      f => f.id == userInterestExpressionFormModel.clusterId
    )?.title

    return (
      <div style={{ padding: '15px' }}>
        <h3>{t`First, select the cluster you are most interested in.`}</h3>
        <p>
          {t`Click on the cluster you are most interested in. To give the administrator a better picture of your preferences, 
                you can also rate all of the clusters with a thumbs up / thumbs down.`}
        </p>
        {selected ? (
          <p className="alert alert-success">{t`You selected: ${selected}`}</p>
        ) : (
          <p className="alert alert-warning">{t`Please click an item below to make a selection`}</p>
        )}
        <div className="row">
          {additional?.map((itm, idx) => {
            const recommendation = itm?.flag ?? {}
            const thumbUp =
              recommendation.rating && recommendation.rating >= 3 ? like : likeInactive
            const thumbDown =
              recommendation.rating && recommendation.rating < 3
                ? dislike
                : dislikeInactive

            return (
              <div
                key={`media.${itm?.url}`}
                style={{ borderBottom: '1px solid #eee', minHeight: '5.5rem' }}
                className={`cluster-listing-icon col-xs-12 col-sm-6 ${
                  idx % 2 == 0 ? 'even' : 'odd'
                }`}>
                <div style={{ padding: '15px 0' }}>
                  <div className="col-xs-10">
                    <a
                      role="button"
                      className="cluster-selector-btn no-style"
                      onClick={() =>
                        dispatch(
                          formActions.change(`${applicationFormName}.clusterId`, itm.id)
                        )}>
                      <div
                        className="col-xs-3 col-md-2"
                        style={{ paddingLeft: '5px', paddingRight: '5px' }}>
                        {defaultThumb(itm)}
                      </div>
                      <div className="col-xs-9 col-md-10">
                        <div className="hover-only" style={{ fontSize: '.8rem' }}>
                          {t`choose:`}
                        </div>
                        {itm?.title}
                      </div>
                    </a>
                  </div>
                  <div className="col-xs-2">
                    <div
                      style={{ whiteSpace: 'nowrap', width: '40px', textAlign: 'right' }}>
                      <a
                        role="button"
                        style={{
                          marginRight: '3px',
                          color:
                            recommendation.rating && recommendation.rating > 3
                              ? '#aaa'
                              : '#ddd',
                          cursor: 'pointer'
                        }}
                        onClick={() =>
                          dispatch(rateCluster(itm, 5)).then(v => updateStateWith(itm, v))}>
                        <img
                          src={thumbUp}
                          alt={t`Thumbs Up for Like Link`}
                          style={{ maxWidth: '17px' }}
                        />
                      </a>
                      <a
                        role="button"
                        style={{
                          color:
                            recommendation.rating && recommendation.rating <= 3
                              ? '#aaa'
                              : '#ddd',
                          cursor: 'pointer'
                        }}
                        onClick={() =>
                          dispatch(rateCluster(itm, 1)).then(v => updateStateWith(itm, v))}>
                        <img
                          src={thumbDown}
                          alt={t`Thumbs Down for Dislike Link`}
                          style={{ maxWidth: '17px' }}
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}{' '}
        </div>
        <button
          className="pull-right btn-success btn"
          disabled={!selected}
          onClick={() => {
            setApplicationStep(2)
          }}>
          {t`Next`}
        </button>
      </div>
    )
  }
  const modalDefault = () => {
    return (
      <div style={{ padding: '15px' }}>
        <h3>{t`Now, we need a little information from you.`}</h3>

        <Form
          model={applicationFormName}
          onSubmit={f => {
            dispatch(applyProfile(profile.type, profile.id, f)).then(v => {
              if (v.planId) {
                setPlanIdReturned(v.planId)
              } else {
                closeModal()
              }
            })
          }}>
          {form => (
            <div>
              <Field
                model={`${applicationFormName}.applicationNotes`}
                form={form}
                label={t`In a few words, please describe why you are interested in this area and why it might be a good fit for you.`}
                required={true}
                control={Control.textarea}>
              </Field>
              <ActionButton
                loading={userInterestExpressionRequest.loading}
                error={userInterestExpressionRequest.error}
                success={receivedResponse(userInterestExpressionRequest) && t`Submitted`}
                className="btn btn-success"
                type="submit">
                {t`Submit`}
              </ActionButton>
            </div>
          )}
        </Form>
      </div>
    )
  }
  const modalBodyContent = () => {
    const topBottom = () => {
      if (profile.applicationsDisabledToWBL && profile.additionalApplicationText) {
        return (
          <div>
            <p
              dangerouslySetInnerHTML={{
                __html: profile.additionalApplicationText
              }}>
            </p>
            <button
              className="btn btn-link pull-right"
              onClick={() => {
                closeModal()
              }}>
              {t`Close`}
            </button>
          </div>
        )
      }

      if (
        userInterestExpressionClustersRequest?.result?.length > 0 &&
        applicationStep == 1
      ) {
        return modalChooseTopInterest()
      }

      return modalDefault()
    }

    if (planIdReturned) {
      return (
        <div>
          <h3>{t`Thank you`}</h3>
          <p>{t`To finish your application, you will need to enter some additional information.`}</p>
          <p>{t`If you wish to do it now, you can click the Go There button. Otherwise you can find a link to enter the information in your my stuff.`}</p>
          <div>
            <Link
              to={`/planning/assignments/detail/${planIdReturned}`}
              className="btn btn-success">
              {t`Go There`}
            </Link>
            <button className="btn btn-link pull-right" onClick={closeModal}>
              {t`Do it later`}
            </button>
          </div>
        </div>
      )
    }

    return (
      <CSSTransitionGroup
        component="div"
        transitionName={'h2animate'}
        transitionEnterTimeout={400}
        transitionLeaveTimeout={400}>
        {React.cloneElement(topBottom(), { key: applicationStep })}
      </CSSTransitionGroup>
    )
    //modalDefault();
  }

  return (
    <div>
      {showAction()}
      <Modal bsSize="large" backdrop="static" show={modalOpen} onHide={closeModal}>
        <Modal.Header style={{ color: 'white', fontWeight: 'bold' }}>
          <button type="button" className="close" aria-label="Close" onClick={closeModal}>
            <span aria-hidden="true">×</span>
          </button>
          <Modal.Title>
            <h2>{t`I am Interested in Finding an Opportunity`}</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ overflow: 'hidden', width: '100%', position: 'relative' }}>
            <CSSTransitionGroup
              component="div"
              transitionName={'h2animate'}
              transitionEnterTimeout={400}
              transitionLeaveTimeout={400}>
              {React.cloneElement(modalBodyContent(), {
                key: planIdReturned
              })}
            </CSSTransitionGroup>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

ExpressInterest.propTypes = {
  profile: PropTypes.object.isRequired,
  selectedCluster: PropTypes.string
}

export { ExpressInterest }
